import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/stores',
    name: 'Stores',
    component: () => import('../views/Stores.vue')
  },
  {
    path: '/help',
    name: 'Help',
    component: () => import('../views/Help.vue')
  },
  {
    path: '/members',
    name: 'Members',
    component: () => import('../views/Members.vue')
  },
  {
    path: '/serviceProject',
    name: 'ServiceProject',
    component: () => import('../components/newsService/ServiceProject.vue')
  },
  {
    path: '/newsInformation',
    name: 'NewsInformation',
    component: () => import('../components/newsService/NewsInformation.vue')
  },
  {
    path: '/newsDetails/:id',
    name: 'NewsDetails',
    component: () => import('../components/newsService/NewsDetails.vue')
  },
  {
    path: '/contactUs',
    name: 'ContactUs',
    component: () => import('../components/newsService/ContactUs.vue')
  },
]

const router = new VueRouter({
  routes
})

export default router
